module.exports = __webpack_public_path__ + "static/media/SittoStandFemale.9f565666.svg";